import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.Drawer.FeedbackPromotion', {
    title: 'Vote for new features!',
    voteNow: 'Vote now',
});
